module.exports = __webpack_public_path__ + "img/lime-green.47673f69.png";